var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('core-multi-lang',{attrs:{"isNormal":""}}),_c('v-layout',{attrs:{"justify-center":"","wrap":""}},[(_vm.imgUrl)?_c('vue-qrcode',{staticStyle:{"width":"100%"},attrs:{"value":_vm.imgUrl}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }